module.exports = __webpack_public_path__ + "assets/media/s21.69d034f4.mp3";